export default function createReducer(initialState, handlers) {
  return (state = initialState, action) =>
    Object.prototype.hasOwnProperty.call(handlers, action.type)
      ? handlers[action.type](state, action)
      : state;
}
